import { Component, OnInit, OnDestroy } from '@angular/core';
import { INoRowsOverlayAngularComp } from 'ag-grid-angular';
import { INoRowsOverlayParams } from 'ag-grid-community';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { TableComponentState } from '../../types/TableComponentState';
import { Store } from '@ngrx/store';
import { NoRowsFunctionInfo } from '../../types/NoRowsFunctionInfo';
import { selectMasterStandingAuthTableState } from '../../../standing-authorizations/reducers/index';
import { filter, takeUntil, delay } from 'rxjs/operators';
import {StandingAuthMasterStatusViewActions} from "../../../standing-authorizations/actions";
import {NoRowsMessageTemplates} from "../../utilities/Constants";

@Component({
  standalone: false,
  selector: 'mm-custom-error-master-standing-auth-table',
  templateUrl: './custom-error-master-standing-auth-table.component.html',
  styleUrls: ['./custom-error-master-standing-auth-table.component.scss'],
})
export class CustomErrorMasterStandingAuthTableComponent implements OnInit, OnDestroy, INoRowsOverlayAngularComp {
  params: INoRowsOverlayParams & { noRowsMessageFn: () => NoRowsFunctionInfo  };
  tableState = new BehaviorSubject<TableComponentState>({
    isInitialLoad: false,
    gridReady: false,
    printClicked: false,
    hasEmptyResponse: false,
    loading: false,
    hasError: false,
    error: '',
  });
  tableState$ = this.tableState.asObservable();
  showSpinner = new BehaviorSubject<{ loading: boolean }>({ loading: false });
  showSpinner$ = this.showSpinner.asObservable();
  private destroy$ = new Subject<void>();
  tableName: string;
  tableTabName: string;
  accountId: string;
  noRowsMessageTemplates = NoRowsMessageTemplates;


  constructor(private store: Store) {}

  ngOnInit(): void {
    this.tableState$ = this.store.select(selectMasterStandingAuthTableState);
    this.tableState$.pipe(
        takeUntil(this.destroy$),
      )
      .subscribe((tableState) => {
          this.showSpinner.next({ loading: tableState.loading });
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  agInit(params: INoRowsOverlayParams & { noRowsMessageFn: () => NoRowsFunctionInfo }): void {
    this.params = params;
    this.tableName = this.params.noRowsMessageFn().tableName;
    this.tableTabName = this.params.noRowsMessageFn().tableTabName;
  }

  refreshAccount(accountId: string): void{
    this.store.dispatch(StandingAuthMasterStatusViewActions.refreshSaMaster({masterAccountId: accountId }));
  }
}
